import { observer } from 'mobx-react'
import { useState } from 'react'

import { SwitchButton } from '@avantstay/backoffice-core'

import { storeHolder } from '@new/__global/components/FastTapeChart/stores/TapeChartStore'
import { SortingFilterIds } from '@new/domains/hotelTapeChart/config/filtersConfig'
import { HotelTapeChartStore } from '@new/domains/hotelTapeChart/stores/HotelTapeChartStore'

import * as S from './GroupByRoomType.styles'

const LOADING_TIMEOUT = 0

const _GroupByRoomType = () => {
  const { apiStore, filterStore } = storeHolder.store as HotelTapeChartStore
  const { toggleForceLoadingOverlay } = apiStore
  const { groupByRoomType, setGroupByRoomType } = filterStore

  const [isChecked, setIsChecked] = useState(groupByRoomType)

  const handleOnChange = (checked: boolean) => {
    toggleForceLoadingOverlay?.(LOADING_TIMEOUT)
    setGroupByRoomType(checked)
    setIsChecked(checked)
  }

  return (
    <S.RowSummaryContainer>
      <SwitchButton
        id={SortingFilterIds.GroupByRoomType}
        defaultChecked={isChecked}
        onChange={({ target: { checked } }) => {
          handleOnChange(checked)
        }}
        titleLeft="Group by Room Type"
      />
    </S.RowSummaryContainer>
  )
}

export const GroupByRoomType = observer(_GroupByRoomType)
